import Button from 'components/Form/Button';
import BasicTable from 'components/Form/Table';
import ModalAnaliseJulia from 'components/Modal/analisejulia';
import TableWrapper from 'components/TableWrapper';
import { UploadFile } from 'components/UploadFile';
import ContainerAuthenticated from 'containers/Authenticated';
import { CoreContext } from 'context/CoreContext';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { toast } from 'react-toastify';
import { CreateFatura, Read, Update } from 'services/financing-proposals';
import { Load, StatusContent, Title } from 'ui/styled';
import { exposeStrapiError, marcadorDiferente, selectColors } from 'utils';
import { formatElapsedTime, parseCurrency } from 'utils/parsers';
import { formatadores, normalizeName } from 'utils/validators';

export default function Proposals() {
  const history = useHistory();
  const navigate = useCallback((to) => history.push(`/${to}`), [history]);
  const { user, filterExpression, setModal } = useContext(CoreContext);
  const [fetching, setFetching] = useState(false);
  const [registers, setRegisters] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProposal, setSelectedProposal] = useState(null);
  // Inicialização do estado loadingFatura
  const [loadingFatura, setLoadingFatura] = useState(() => {
    const storedLoading = sessionStorage.getItem('proposalsLoadingFatura');
    try {
      const parsed = storedLoading ? JSON.parse(storedLoading) : {};
      return Object.keys(parsed).filter((id) => parsed[id] === 'anexando');
    } catch (e) {
      console.error('Erro ao parsear proposalsLoadingFatura:', e);
      return [];
    }
  });

  const reloadPage = () => history.go(0);

  // Funções para gerenciar o sessionStorage
  const updateStorage = (propostaId, status) => {
    let storageData =
      JSON.parse(sessionStorage.getItem('proposalsLoadingFatura')) || {};
    if (status === false) {
      delete storageData[propostaId];
    } else {
      storageData[propostaId] = status;
    }
    sessionStorage.setItem(
      'proposalsLoadingFatura',
      JSON.stringify(storageData)
    );
    return storageData;
  };

  const readStorage = (propostaId) => {
    const storageData =
      JSON.parse(sessionStorage.getItem('proposalsLoadingFatura')) || {};
    return storageData[propostaId] || null;
  };
  const openModalAnaliseJulia = useCallback(
    (row) => {
      const a = registers.find((element) => element.id === row.id);
      if (a && a.julia_fatura) {
        a.julia_fatura.proposta = row.id;
        a.julia_fatura.cep_instalacao = a.endereco_instalacao.cep;
        setSelectedProposal(a.julia_fatura);
        setIsModalOpen(true);
      } else {
        toast.error('Favor verificar. Fatura não foi localizada.');
      }
    },
    [registers]
  );

  const closeModal = ({ isSubmit }) => {
    setIsModalOpen(false);
    setSelectedProposal(null);
    if (isSubmit) {
      reloadPage();
    }
  };

  const init = async () => {
    setFetching(true);
    try {
      const result = await Read('?filters[status]=pendente');

      if (result && !exposeStrapiError(result)) {
        const nresult = result?.results?.sort((a, b) => b.id - a.id);
        setRegisters(nresult);
        // Limpar estados obsoletos no sessionStorage

        const storageData =
          JSON.parse(sessionStorage.getItem('proposalsLoadingFatura')) || {};
        const validIds = nresult.map((item) => item.id.toString());
        Object.keys(storageData).forEach((key) => {
          if (!validIds.includes(key)) {
            delete storageData[key];
          }
        });
        sessionStorage.setItem(
          'proposalsLoadingFatura',
          JSON.stringify(storageData)
        );
        setLoadingFatura(
          Object.keys(storageData).filter(
            (id) => storageData[id] === 'anexando'
          )
        );
      }
    } catch (error) {
      console.error('Erro ao inicializar dados:', error);
      toast.error('Erro ao carregar propostas.');
    } finally {
      setFetching(false);
    }
  };

  const saveFatura = useCallback(async (dados) => {
    const propostaId = dados?.proposta?.toString();

    if (!propostaId) {
      toast.error('ID da proposta inválido.');
      return;
    }

    updateStorage(propostaId, 'anexando');

    setLoadingFatura((prev) => {
      if (!prev.includes(propostaId)) {
        return [...prev, propostaId];
      }
      return prev;
    });

    const dadoTratado = {
      cliente: dados.cliente,
      fatura: dados.fatura.id,
      proposta: propostaId,
    };

    toast.info('Fatura enviada, aguarde o processamento!', {
      position: 'top-right',
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'light',
    });

    let response = null;
    try {
      const ret = await CreateFatura({ data: dadoTratado });

      if (ret.notas === 'reprovado') {
        throw new Error(
          'Esta não é uma imagem válida. Por favor, tente novamente com outra imagem.'
        );
      }

      if (ret.resposta_ocr) {
        if (ret?.resposta_ocr?.faturaenergia === 'nao') {
          response = {
            type: 'error',
            message:
              'A imagem anexada não corresponde a uma fatura de energia!',
          };
        } else if (ret.resposta_ocr.resolucao === 'ruim') {
          response = {
            type: 'warn',
            message:
              'Infelizmente não foi possivel ler a fatura devido a baixa qualidade da imagem. Por favor, anexe uma imagem de melhor qualidade.',
          };
        } else if (ret.resposta_ocr.leituraAtual === 'nao') {
          response = {
            type: 'warn',
            message:
              'Foi identificado que a data de leitura da fatura tem mais de 60 dias. Por favor, solicite uma verificação dos dados da análise ou anexe uma fatura mais recente.',
          };
        } else {
          response = {
            type: 'success',
            message: 'Fatura anexada com sucesso!',
          };
        }
        if (response.type === 'error') {
          throw new Error(response.message);
        }
      }

      const formatedMessage = response.message || 'Tente novamente.';

      toast[response.type](formatedMessage, {
        position: 'top-right',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
      });

      await init();
    } catch (error) {
      toast.error(error.message, {
        position: 'top-right',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
      });
    } finally {
      updateStorage(propostaId, false);
      setLoadingFatura((prev) => prev.filter((id) => id !== propostaId));
    }
  }, []);

  const handleTagRenderCell = useCallback(
    ({ row }) => {
      const isAnalyzing =
        loadingFatura.includes(row.id.toString()) ||
        readStorage(row.id.toString()) === 'anexando';

      const hasFatura = !!row?.url_fatura;

      const getTagValues = (status) => {
        const tagOptions = [
          {
            status: 'review',
            tagColor: 'Analise',
            tagMessage: 'Em análise',
          },
          {
            status: 'attach',
            tagColor: 'pendente',
            tagMessage: 'Anexar Fatura',
          },
        ];

        return tagOptions.filter((tag) => tag.status === status)[0];
      };

      const tagStatus = hasFatura ? 'review' : 'attach';

      const { status, tagColor, tagMessage } = getTagValues(tagStatus);

      if (isAnalyzing)
        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Load />
          </div>
        );

      if (status === 'review')
        return (
          <StatusContent color={selectColors(tagColor)}>
            {tagMessage}
          </StatusContent>
        );

      if (status === 'attach')
        return (
          <UploadFile
            buttonConfigs={{ color: selectColors(tagColor) }}
            onConfirm={(file) => {
              saveFatura({
                fatura: file,
                proposta: row.id,
                cliente: row.customer,
              });
              setModal(null);
            }}
            title={tagMessage}
          />
        );
    },
    [loadingFatura, saveFatura, setModal]
  );

  const handleAnaliseJuliaRenderCell = useCallback(
    ({ row }) => {
      const hasFatura = !!row?.url_fatura;
      return loadingFatura.includes(row.id.toString()) ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Load />
        </div>
      ) : (
        <Button
          disabled={!hasFatura}
          onClick={() => {
            if (row.tipo === 'enviado') {
              setModal({
                type: 'encerrasol',
                dados: row,
                origem: 'Elegíveis',
                reload: () => init(),
              });
            } else {
              if (
                row.curadoria_analise === 'Sim' ||
                row.curadoria_analise_bot === 'Ativo'
              ) {
                if (row.etapa_monitoramento === 'fatura cliente') {
                  toast.info(
                    'Removido a proposta que estava na curadoria por causa da fatura.'
                  );
                  const payload = {
                    data: {
                      curadoria_analise_bot: null,
                      curadoria_analise: 'Analisado',
                    },
                  };
                  Update(payload, row.id);
                  setTimeout(() => {
                    window.location.href = '/proposals';
                  }, 2000);
                } else {
                  toast.info(
                    'Proposta na curadoria não foi removida, verifique na curadoria se é da etapa da fatura.'
                  );
                }
              } else {
                openModalAnaliseJulia(row);
              }
            }
          }}
          color="blue"
          nospace
          mbutton
          small
        >
          {row.tipo === 'enviado'
            ? 'Sol em conversa'
            : row.curadoria_analise === 'Sim' ||
                row.curadoria_analise_bot === 'Ativo'
              ? 'Remover da Curadoria'
              : 'Verificar'}
        </Button>
      );
    },
    [loadingFatura, openModalAnaliseJulia, setModal]
  );

  const rows = useMemo(() => {
    if (!registers) {
      return [];
    }
    const mapRows = (item) => ({
      id: item?.id,
      date: item?.createdAt,
      formatedDate: formatadores.TIMESTAMP_TO_BR(item?.createdAt),
      cod_proposta_externa: normalizeName(item?.cod_proposta_externa),
      distributor: normalizeName(item?.distribuidor?.trade_name),
      integrator: normalizeName(item?.integrador?.nome_fantasia),
      customer: normalizeName(item?.informacoes_cliente?.nome_completo),
      value: parseCurrency(item?.informacoes_projeto?.custo_total_projeto),
      tag: item?.url_fatura ? 'Em analise' : 'Anexar Fatura',
      UC: item?.informacoes_projeto?.unidade_consumidora,
      city: item?.endereco_instalacao?.cidade,
      uf: item?.endereco_instalacao?.estado,
      dealership: item?.informacoes_projeto?.concessionaria,
      model_brand: item?.informacoes_projeto?.marca_placas,
      inverter_brand: item?.informacoes_projeto?.marca_inversores,
      modules: item?.informacoes_projeto?.quantidade_placas,
      power_kwp: `Potência kWp ${item?.informacoes_projeto?.potencia_kWp}`,
      kwh_month: `kWh / Mês ${parseInt(item?.informacoes_projeto?.geracao_energia_estimada / 12)}`,
      ciencia: item?.compra_ciente,
      fatura: item?.fatura,
      cliente_Id: item?.informacoes_cliente?.cpf,
      url_fatura: item?.url_fatura,
      distribuidor: item?.distribuidor,
      documentos: item?.documentos,
      julia_fatura: item?.julia_fatura,
      espelho_pdf: item?.espelho_pdf?.[0]?.url,
      curadoria_analise: item?.curadoria_analise, // Assumindo que este campo está no backend
      curadoria_analise_bot: item?.curadoria_analise_bot,
      etapa_monitoramento: item?.monitoring?.etapa,
      tipo: item?.monitoring?.tipo,
      idchat: item?.monitoring?.chatid_bot,
      msgtelefone: item?.monitoring?.telefone,
      cnpj_integrador: item?.integrador?.cnpj,
      cnpj_integrador_clean: item?.integrador?.cnpj.replace(/\D/g, ''),
      cpf_cnpj: item?.cliente?.cpf || item?.cliente?.cnpj,
      cpf_cnpj_clean: item?.cliente?.cpf
        ? item?.cliente?.cpf.replace(/\D/g, '')
        : item?.cliente?.cnpj.replace(/\D/g, ''),
    });

    if (user?.administrador) {
      return registers.map(mapRows);
    }

    const accessibleDistributorIds = [];
    if (user?.distribuidor?.id) {
      accessibleDistributorIds.push(user.distribuidor.id);
    }
    if (user?.distribuidores?.length > 0) {
      user.distribuidores.forEach((dist) =>
        accessibleDistributorIds.push(dist.id)
      );
    }
    const filteredRegisters = registers.filter((item) =>
      accessibleDistributorIds.includes(item?.distribuidor?.id)
    );
    return filteredRegisters.map(mapRows);
  }, [registers, user]);

  const columns = useMemo(() => {
    const baseColumns = [
      {
        title: 'Id',
        sortable: true,
        ref: 'id',
        renderCell: ({ row }) => {
          // Condição: Se o campo 'curadoria_analise' for 'Analisado'
          const isAnalisado = row?.curadoria_analise === 'Analisado';
          const id = row?.id;
          if (isAnalisado) {
            return marcadorDiferente(id, '!');
          }
          return id;
        },
      },
      {
        title: 'Data',
        sortable: true,
        ref: 'date',
        renderCell: ({ row }) => formatadores.TIMESTAMP_TO_BR(row.date),
      },
      {
        title: 'Tempo',
        renderCell: ({ row }) => {
          const diffDays = formatadores.DIFF_DAYS_NOW(row?.date);
          return (
            <span style={{ color: diffDays >= 20 ? 'red' : 'inherit' }}>
              {formatElapsedTime(row?.date)}
            </span>
          );
        },
      },
      // Inserir coluna "Distribuidora" condicionalmente
      ...(user?.administrador ||
      (user?.distribuidor && user?.distribuidores?.length > 0)
        ? [
            {
              title: 'Distribuidora',
              sortable: true,
              ref: 'distributor',
            },
          ]
        : []),
      { title: 'Proposta', ref: 'cod_proposta_externa' },
      { title: 'Integrador', sortable: true, ref: 'integrator' },
      { title: 'Cliente', sortable: true, ref: 'customer' },
      { title: 'Valor (R$)', ref: 'value' },
      {
        title: 'TAG',
        ref: 'tag',
        renderCell: handleTagRenderCell,
      },
      // Inserir coluna "Espelho da Proposta", "Análise da Julia" e "Observações" condicionalmente
      ...(user?.administrador
        ? [
            {
              title: 'Espelho da Proposta',
              ref: 'espelho',
              renderCell: ({ row }) => (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <Button
                    onClick={() => navigate(`proposals/financing/${row?.id}`)}
                    color={'blue'}
                    nospace
                    mbutton
                    small
                  >
                    Visualizar
                  </Button>
                </div>
              ),
            },
            {
              title: 'Análise da Julia',
              renderCell: handleAnaliseJuliaRenderCell,
            },
            {
              title: 'Observações',
              renderCell: ({ row }) => (
                <Button
                  onClick={() => {
                    setModal({
                      type: 'observacao',
                      dados: row,
                      origem: 'Elegíveis',
                      reload: () => init(),
                    });
                  }}
                  color="botao"
                  nospace
                  mbutton
                  small
                >
                  Adicionar
                </Button>
              ),
            },
          ]
        : []),
    ];
    return baseColumns;
  }, [
    user,
    navigate,
    setModal,
    handleTagRenderCell,
    handleAnaliseJuliaRenderCell,
  ]);

  useEffect(() => init(), []);

  return (
    <ContainerAuthenticated>
      <Title>Propostas</Title>
      <TableWrapper title={'Elegíveis'} search>
        <BasicTable
          loading={fetching}
          columns={columns}
          rows={rows?.filter(filterExpression)}
          pagination
        />
      </TableWrapper>
      {isModalOpen && (
        <ModalAnaliseJulia
          julia_fatura={selectedProposal}
          onClose={closeModal}
          reloadContent={reloadPage}
        />
      )}
    </ContainerAuthenticated>
  );
}
